import PropTypes from 'prop-types';
import React from 'react';
import { DateRangePicker } from 'react-dates';
import { Button } from 'react-bootstrap';
import moment from 'moment';

import HotelList from './HotelList';
import HotelMap from './HotelMap';
import HotelAddModal from './HotelAddModal';
import HotelDetailModal from './HotelDetailModal';
import { findByUID } from '../../../core/utils';

class HotelBuildBid extends React.Component {
  constructor(props) {
    super(props);

    const focusedInput = null;

    this.state = {
      focusedInput,
      startDate: moment(props.event.start),
      endDate: moment(props.event.end),
      viewMap: false,
      showAddHotel: false,
      showHotelDetail: false,
    };

    this.onDatesChange = this.onDatesChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeHotelDetailModal = this.closeHotelDetailModal.bind(this);
    this.handleViewToggle = this.handleViewToggle.bind(this);
    this.handleStayToggle = this.handleStayToggle.bind(this);
    this.handleAddHotel = this.handleAddHotel.bind(this);
    this.handleDisplayHotel = this.handleDisplayHotel.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    console.log('is Fetching: ', nextProps.isFetching);
    console.log('need Fetch:', nextProps.needFetch);
    if (nextProps.needFetch && nextProps.event.event_type === 'stay') {
      this.startHotelSearch(nextProps);
    }
  }
  onFocusChange(focusedInput) {
    this.setState({ focusedInput });
  }
  onDatesChange({ startDate, endDate }) {
    this.setState({ startDate, endDate });
    const payload = {
      start: startDate.format('YYYY-MM-DD'),
      end: endDate.format('YYYY-MM-DD'),
    };
    this.props.editGroupEvent(this.props.event.id, payload);
  }
  startHotelSearch(props) {
    this.props.searchHotels(props.event.id);
    const startDate = moment(props.event.start);
    const endDate = moment(props.event.end);
    this.setState({ startDate, endDate });
  }
  closeModal() {
    this.setState({
      showAddHotel: false,
    });
  }
  closeHotelDetailModal() {
    this.setState({
      showHotelDetail: false,
    });
  }
  handleViewToggle(e) {
    e.preventDefault();
    this.setState({ viewMap: !this.state.viewMap });
  }
  handleStayToggle(e) {
    e.preventDefault();
    const payload = {};
    if (this.props.event.event_type === 'stay') {
      payload.event_type = 'nost';
    } else if (this.props.event.event_type === 'nost') {
      payload.event_type = 'stay';
    }
    this.props.editGroupEvent(this.props.event.id, payload);
  }
  handleAddHotel(e) {
    e.preventDefault();
    this.setState({
      showAddHotel: true,
    });
  }

  handleDisplayHotel(hotel) {
    this.setState({
      hotel: this.findHotel(hotel),
      showHotelDetail: true,
    });
  }
  findHotel(id) {
    const idx = this.props.hotels.findIndex(findByUID, id);
    if (idx === -1) {
      console.log('that should not happen... findHotel', id);
      return {};
    }
    return this.props.hotels[idx];
  }

  render() {
    const { focusedInput, startDate, endDate } = this.state;
    if (this.props.event.event_type !== 'stay') {
      return (
        <div className="center-block col-sm-6 no-hotel">
          <p>No hotel for this group at this location.</p>
          <Button onClick={this.handleStayToggle}>
            <span className="fa-stack fa-lg">
              <i className="fa fa-square fa-stack-2x" />
              <i className="fa fa-stack-1x fa-hotel fa-inverse" />
            </span>
            Add Hotel
          </Button>
        </div>
      );
    }
    let viewButton = (
      <Button onClick={this.handleViewToggle}>
        <span className="fa-stack fa-lg">
          <i className="fa fa-square fa-stack-2x" />
          <i className="fa fa-stack-1x fa-map-marker fa-inverse" />
        </span>
        Map
      </Button>
    );
    let hotelView = (
      <HotelList
        hotels={this.props.hotels}
        eventId={this.props.event.id}
        favoriteHotel={this.props.favoriteHotel}
        selectHotel={this.props.selectHotel}
        place={this.props.event.place}
        displayHotel={this.handleDisplayHotel}
      />
    );
    if (this.props.isFetching) {
      hotelView = (
        <p className="text-center">
          <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading hotels...</span>
          <br />Catch is searching for hotels!
        </p>
      );
    }
    if (this.state.viewMap) {
      viewButton = (
        <Button onClick={this.handleViewToggle}>
          <span className="fa-stack fa-lg">
            <i className="fa fa-square fa-stack-2x" />
            <i className="fa fa-stack-1x fa-table fa-inverse" />
          </span>
          Table
        </Button>
      );
      hotelView = (
        <HotelMap
          hotels={this.props.hotels}
          eventId={this.props.event.id}
          favoriteHotel={this.props.favoriteHotel}
          selectHotel={this.props.selectHotel}
          place={this.props.event.place}
        />
      );
    }

    return (
      <div>
        <div className="info-panel spacing">
          <DateRangePicker
            onDatesChange={this.onDatesChange}
            onFocusChange={this.onFocusChange}
            focusedInput={focusedInput}
            startDate={startDate}
            endDate={endDate}
          />
          <Button bsStyle="warning">
            <span className="fa-stack fa-lg">
              <i className="fa fa-arrow-circle-left" />
            </span>
            Verify In/Out Days
          </Button>
        </div>
        <div className="info-panel spacing">
          <Button onClick={this.handleStayToggle}>
            <span className="fa-stack fa-lg">
              <i className="fa fa-hotel fa-stack-1x" />
              <i className="fa fa-ban fa-stack-2x" />
            </span>
            No Hotel
          </Button>
          {viewButton}
          <Button onClick={this.handleAddHotel}>
            <span className="fa-stack fa-lg">
              <i className="fa fa-square fa-stack-2x" />
              <i className="fa fa-stack-1x fa-plus fa-inverse" />
            </span>
            Add Hotel
          </Button>
          <Button onClick={this.props.showPrefs} title="Show Hotel Search Preferences">
            <span className="fa-stack fa-lg">
              <i className="fa fa-square fa-stack-2x" />
              <i className="fa fa-stack-1x fa-cog fa-inverse" />
            </span>{' '}
            Search Preferences
          </Button>
        </div>
        <div className="planner">
          {hotelView}
          {this.state.showAddHotel && (
            <HotelAddModal
              event={this.props.event.id}
              show={this.state.showAddHotel}
              onClose={this.closeModal}
              displayHotel={this.handleDisplayHotel}
            />
          )}
          {this.state.showHotelDetail && (
            <HotelDetailModal
              hotel={this.state.hotel}
              show={this.state.showHotelDetail}
              onClose={this.closeHotelDetailModal}
            />
          )}
        </div>
      </div>
    );
  }
}

HotelBuildBid.propTypes = {
  hotels: PropTypes.arrayOf(PropTypes.object).isRequired,
  needFetch: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  event: PropTypes.object.isRequired,
  searchHotels: PropTypes.func.isRequired,
  selectHotel: PropTypes.func.isRequired,
  favoriteHotel: PropTypes.func.isRequired,
  editGroupEvent: PropTypes.func.isRequired,
  showPrefs: PropTypes.func.isRequired,
};

HotelBuildBid.defaultProps = {
  hotels: [],
};
export default HotelBuildBid;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelBuildBid.js